import { Button, Col, Row, Spin } from 'antd';
import Comments from '../Attachment/Comment';
import DownloadAttachment from '../Attachment/DownloadAttachment';
import '../../../../styles/pages/warehouse/_inbound/_index.scss';
import { useActions } from '@root/core/hooks/useActions';
import {
  ApproveInbound,
  bodyCommentWarehouse,
  InitDetailInbound
} from '@root/state/reducers/inboundReducer/inboundReducers';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import Popup from '@root/core/components/Popup';
import { useState } from 'react';

import { useParams } from 'react-router-dom';
import moment from 'moment';
import { formatDateTime } from '@root/utils/helpers/formatDate';

interface ParamType {
  id: string;
}
function CustomersAttachment() {
  const { id } = useParams<ParamType>();
  const { data } = useTypedSelector<InitDetailInbound>(
    (state) => state.detailInboundReducer
  );

  // get comment

  const [comment, useComment] = useState('');

  const bodyApproved: bodyCommentWarehouse = {
    warehouseComment: comment
  };

  // attachments
  const attachments = data?.data?.attachments;

  const { approveInboundHandle } = useActions();

  const showModalHanle = () => {
    setShowModal(true);
  };

  // handle approve

  const { approvedLoading } = useTypedSelector<ApproveInbound>(
    (state) => state.approveInboundReducer
  );

  const handleOk = () => {
    approveInboundHandle(id, bodyApproved);
    setShowModal(false);
  };
  const handleCancel = () => {
    setShowModal(false);
  };

  const [showModal, setShowModal] = useState<boolean>(false);

  const status = data?.data?.status;
  return (
    <>
      {data?.data && (
        <>
          <Spin spinning={approvedLoading} className="loading-forgot">
            <Row gutter={[16, 16]} style={{ marginBottom: '10px' }}>
              <Col
                className="gutter-row"
                span={8}
                style={{ marginLeft: '10px' }}
              >
                <div>
                  <DownloadAttachment
                    data={attachments}
                    label="Customer’s attachments"
                    typeButton="Download"
                  />
                </div>
              </Col>
              <Col className="gutter-row" span={15}>
                <div>
                  <Comments
                    title="Comment from Customer"
                    message={data?.data?.sellerComment}
                    date={
                      data?.data?.updatedAt
                        ? formatDateTime(data?.data?.updatedAt)
                        : ''
                    }
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col span={20} style={{ marginLeft: '10px' }}>
                <Comments
                  title="Comment from Warehouse"
                  width="75%"
                  message={data?.data?.warehouseComment}
                  date={
                    data?.data?.warehouseCommentDate
                      ? formatDateTime(data?.data?.warehouseCommentDate)
                      : ''
                  }
                  comment={useComment}
                  status={status}
                />
              </Col>
              <Col style={{ display: 'flex', alignItems: 'flex-end' }}>
                {data?.data?.status === 'Request' && (
                  <Button
                    type="primary"
                    style={{ width: '95px', background: '#2b2c51' }}
                    className="approve-button"
                    onClick={showModalHanle}
                  >
                    Approve
                  </Button>
                )}
              </Col>
            </Row>
          </Spin>

          <Popup
            visible={showModal}
            title="Approve"
            text="Do you want to approve this inbound?"
            action_oke={handleOk}
            action_cancel={handleCancel}
          />
        </>
      )}
    </>
  );
}

export default CustomersAttachment;
